import { BsWifiOff } from "react-icons/bs";

export default function InternetPageError() {
  const handleRetry = () => {
    window.location.reload();
  };

  const handleGoHome = () => {
    window.location.href = '/';
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-white text-center px-4">
      <BsWifiOff className="text-8xl text-red-500 mb-6" />
      <h1 className="text-2xl font-bold mb-4">네트워크 연결이 끊어졌습니다</h1>
      <p className="text-gray-600 mb-8">인터넷 연결을 확인한 후 다시 시도해주세요.</p>
      <div className="flex space-x-4">
        <button 
          onClick={handleRetry} 
          className="px-6 py-3 bg-MainColor text-white font-semibold rounded-md hover:bg-opacity-70 transition duration-300">
          재시도
        </button>
        <button 
          onClick={handleGoHome} 
          className="px-6 py-3 bg-gray-200 text-gray-600 font-semibold rounded-md hover:bg-gray-300 transition duration-300">
          홈으로 돌아가기
        </button>
      </div>
    </div>
  );
}
